import { useDispatch } from 'react-redux'
import { showError } from '@calendly/alert'
import { GoogleLogin } from '@react-oauth/google'

import { useI18n } from 'locales'

import { useBookingRedirect } from '../hooks/use_booking_redirect'
import { useTracking } from '../hooks/use_tracking'
import {
  DEFAULT_WIDTH,
  DEFAULT_SHAPE,
  DEFAULT_THEME,
  DEFAULT_TYPE,
  DEFAULT_LOGO_ALIGNMENT,
  DEFAULT_TEXT,
  DEFAULT_CONTEXT
} from '../constants'

export const GoogleSignUpButton = ({
  width = DEFAULT_WIDTH,
  shape = DEFAULT_SHAPE,
  theme = DEFAULT_THEME,
  type = DEFAULT_TYPE,
  logoAlignment = DEFAULT_LOGO_ALIGNMENT,
  text = DEFAULT_TEXT,
  context = DEFAULT_CONTEXT,
  trackEventName = 'CTA Clicked',
  trackEventProperties = {
    cta_text: 'google_button',
    cta_key: 'booking_page_availability',
  },
  signupSource = 'booking_page_availability',
}) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { encodedBookingRedirect } = useBookingRedirect()
  const track = useTracking()

  return (
    <GoogleLogin
      shape={shape}
      theme={theme}
      type={type}
      logo_alignment={logoAlignment}
      width={width}
      scope="email profile https://www.googleapis.com/auth/calendar"
      text={text}
      context={context}
      click_listener={() => track(trackEventName, trackEventProperties)}
      onSuccess={(credentialResponse) => {
        const { credential } = credentialResponse
        const successLocation = '/users/auth/google_onetap'.concat(
          `?credential=${credential}`,
          `&signup_source=${signupSource}`,
          `&booking_redirect=${encodedBookingRedirect}`
        )
        window.location.href = successLocation
      }}
      onError={() => {
        dispatch(showError(i18n.t('errors.default_no_action')))
      }}
      use_fedcm_for_prompt
    />
  )
}
